var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#8673FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7605 12.3932H8.94899L12.3667 9.00265C12.8094 8.56347 12.8094 7.86076 12.3667 7.43914C12.1542 7.22833 11.8709 7.12292 11.5698 7.12292C11.2688 7.12292 10.9854 7.2459 10.7729 7.45671L5.46045 12.7445C5.01774 13.1837 5.01774 13.8864 5.46045 14.3081L10.7729 19.5959C10.9854 19.8067 11.2688 19.9121 11.5698 19.9121C11.8709 19.9121 12.1542 19.8067 12.3667 19.5959C12.5792 19.3851 12.7032 19.104 12.7032 18.8054C12.7032 18.5067 12.5792 18.2256 12.3844 18.0148L8.94899 14.6067H20.7605C21.3802 14.6067 21.8761 14.1148 21.8761 13.5C21.8761 12.8851 21.3802 12.3932 20.7605 12.3932Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashBack);
export default __webpack_public_path__ + "static/media/dash-back.5e8b1873ce837cdd1e8e3135f92b678f.svg";
export { ForwardRef as ReactComponent };